import React from 'react';
import { Chip } from '@mui/material';

interface StatusBadgeProps {
    status: {
        id: number;
        name: string;
        badge?: string;
    };
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {

    // Map Laravel badge classes to Material-UI colors
    const getBadgeColor = (badgeClass?: string) => {
        switch (badgeClass) {
            case 'badge-light':
                return 'default';
            case 'badge-warning':
                return 'warning';
            case 'badge-primary':
                return 'primary';
            case 'badge-info':
                return 'info';
            case 'badge-success':
                return 'success';
            case 'badge-danger':
                return 'error';
            case 'badge-dark':
                return 'default';
            case 'badge-secondary':
                return 'secondary';
            default:
                return 'default';
        }
    };

    // Fallback color mapping based on status ID if badge class is not available
    const getFallbackColor = (statusId: number) => {
        switch (statusId) {
            case 1: // Booked
                return 'default';
            case 2: // Ready for Pickup
                return 'warning';
            case 3: // Picked Up
                return 'primary';
            case 4: // Arrived at hub
                return 'info';
            case 5: // Ready to Ship
                return 'primary';
            case 6: // Shipped
                return 'info';
            case 7: // Arrived at Destination
                return 'secondary';
            case 8: // Assigned to Rider
                return 'primary';
            case 9: // Delivered
                return 'success';
            case 10: // Refused
                return 'error';
            case 11: // Re-attempt to Deliver
                return 'default';
            case 12: // Pending for RTO
                return 'default';
            case 13: // Returned to Origin
                return 'primary';
            case 14: // Arrived at Origin
                return 'info';
            case 15: // Return Ready to Ship
                return 'primary';
            case 16: // Return Assigned to Rider
                return 'primary';
            case 17: // Return Shipped
                return 'info';
            case 18: // Returned to Consigner
                return 'secondary';
            case 19: // Cancelled
                return 'error';
            case 20: // Pending for Pickup
                return 'error';
            case 21: // Dispatched for Delivery
                return 'warning';
            case 22: // Delivery Sheet Checked In
                return 'info';
            case 23: // Delivery Sheet Closed
                return 'success';
            case 24: // Lost
                return 'error';
            case 25: // Short Arrived
                return 'error';
            case 26: // Paid
                return 'success';
            default:
                return 'default';
        }
    };

    const color = status.badge ? getBadgeColor(status.badge) : getFallbackColor(status.id);

    return (
        <Chip
            label={status.name}
            color={color as any}
            size="small"
            variant="filled"
            sx={{
                fontWeight: 500,
                fontSize: '0.75rem',
                height: '24px',
            }}
        />
    );
};

export default StatusBadge;
